"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalUrl = void 0;
var isExternalUrl = function (to) { return to ? (to.charAt(0) === "/" ? false : true) : null; };
exports.isExternalUrl = isExternalUrl;
